import type { CatalogueEntrySummary } from "@/services/api/guardiansv2/types";

/** Stable React list key — catalogue ``key`` is not unique across tenants. */
export function catalogueEntryReactKey(
  entry: Pick<CatalogueEntrySummary, "key" | "id" | "client_id">,
  index = 0,
): string {
  if (entry.id) return entry.id;
  const client = entry.client_id?.trim();
  if (client) return `${entry.key}:${client}`;
  return `${entry.key}:${index}`;
}
